import { ConfirmationModal, Text, ValidationMessage } from '@modusign/design-system';
import { Controller, useForm } from 'react-hook-form-v7';
import { useMount } from 'react-use';

import ContactCustomInput from '@app/features/addressBook/components/ContactInputForm/ContactCustomInput';
import { validateName } from '@app/features/addressBook/libs';

export interface ContactCopyNameInputModalProps {
  contactName: string;
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: (name: string) => void;
}

export default function ContactCopyNameInputModal({
  contactName,
  isOpen,
  onCancel,
  onConfirm,
}: ContactCopyNameInputModalProps) {
  const {
    control,
    formState: { errors, isValid },
    getValues,
    trigger,
  } = useForm<{ name: string }>({
    defaultValues: { name: `${contactName} (사본)` },
    mode: 'onChange',
  });

  useMount(() => {
    setTimeout(() => trigger(), 100);
  });

  return (
    <ConfirmationModal
      confirmButtonLabel="만들기"
      disabled={!isValid}
      isOpen={isOpen}
      maxWidth="xs"
      title="사본 만들기 안내"
      variant="warning"
      onClose={onCancel}
      onConfirm={() => {
        onConfirm(getValues().name);
      }}
    >
      <Text as="p" mb={6} textAlign="center">
        연락처의 이름은 최대 30자까지 입력할 수 있습니다.
      </Text>
      <Controller
        control={control}
        name="name"
        render={({ field: { name, ref, value, onChange }, fieldState: { invalid } }) => (
          <ContactCustomInput
            aria-label="휴대폰"
            autoFocus
            id="contact-input-form-phone-number"
            isInvalid={invalid}
            name={name}
            placeholder="30자 이내로 입력"
            ref={ref}
            type="text"
            value={value}
            onChange={onChange}
            onClear={value ? () => onChange('') : undefined}
          />
        )}
        rules={{
          validate: (value) => validateName(value),
        }}
      />
      {errors.name && <ValidationMessage>{errors.name.message}</ValidationMessage>}
    </ConfirmationModal>
  );
}
